<template>
    <AlertMessage
        type="danger"
        :show-icon="true"
        >{{ $tm('general.savefailed') }}</AlertMessage
    >
</template>
<script lang="ts" setup>
import { AlertMessage } from '@/components';
import { $tm } from '@/locize';
</script>
